/**
 * Display values for UI selection
 */
export const CAN_LIVE_WITH = [
  'Birds',
  'Cats',
  'Chickens',
  'Children - Young',
  'Children - Old',
  'Dogs',
  'Rodents',
  'Horses',
  'Livestock - Large',
  'Livestock - Small',
  'Needs To Be Only Pet',
  'Rabbits',
  'Unknown',
] as const

/**
 * API-allowed values for canLiveWith field
 */
export const API_CAN_LIVE_WITH = [
  'Cats',
  'Older Children (12+)',
  'Unknown',
  'Birds',
  'Chickens',
  'Children',
  'Dogs',
  'Guinea Pigs, Rats, Or Hamsters',
  'Horses',
  'Large Livestock (cows)',
  'Livestock',
  'Rabbits',
  'Needs To Be Only Pet',
] as const

/**
 * Maps UI display values to API submission values for pet compatibility.
 * If a display value doesn't have a mapping, the display value itself is used for API submission.
 */
export const CAN_LIVE_WITH_API_MAPPING: Record<string, string> = {
  'Children - Young': 'Children',
  'Children - Old': 'Older Children (12+)',
  Rodents: 'Guinea Pigs, Rats, Or Hamsters',
  'Livestock - Large': 'Large Livestock (cows)',
  'Livestock - Small': 'Livestock',
}

/**
 * Helper function to get the API value from a display value
 */
export function getApiValueFromDisplay(displayValue: string): string {
  return CAN_LIVE_WITH_API_MAPPING[displayValue] || displayValue
}
